<template>
  <button
    id="ask-ai-gecx-button"
    :class="{
      'ask-ai-btn-condensed': !isDesktop && isMcom,
      'ask-ai-gecx-btn': isDesktop || !isMcom,
    }"
    data-is-nuxt-gecx="true"
    onclick="
      ((event) => {
        // Source value must match ASK_AI_HEADER_BTN_ENTRY_POINT in shared/constants/common/googleAgentEventNames.js
        window.openAskAi && window.openAskAi({ source: 'ASK_AI_HEADER_BTN_ENTRY_POINT' });
      })(event)
    "
  >
    <AskAIButtonContent />
  </button>
</template>

<script setup>
import { computed } from 'vue';
import AskAIButtonContent from './AskAIButtonContent';
import { GET_IS_DESKTOP_VIEW } from '#shared/types/getters';

const navViewType = useNavViewType();
const { isMcom } = useEnvProps();
const isDesktop = computed(() => navViewType[GET_IS_DESKTOP_VIEW]);
</script>

<style lang="scss" scoped>
.ask-ai-btn-condensed {
  cursor: pointer;
  position: relative;
}

.ask-ai-gecx-btn {
  font-size: 14px;
  box-sizing: border-box;
  cursor: pointer;
  white-space: nowrap;
  border: none;
  display: inline-flex;

  &[data-is-visible='false'] {
    display: none;
  }
}
</style>

<style lang="scss" brand="mcom" scoped>
@keyframes askAiBtnAnim {
  from {
    transform: rotateY(0);
  }

  to {
    transform: rotateY(360deg);
  }
}

.ask-ai-gecx-btn {
  --ask-ai-btn-width: 107px;
  font-family: 'Macys Sans';
  color: var(--macys-black, #000);
  font-weight: 700;
  line-height: 36px;
  border-radius: 20px;
  padding: 2px;
  width: var(--ask-ai-btn-width);
  height: 40px;
  position: relative;
  z-index: 2;
  overflow: hidden;
  background: #e01a2b;

  &::after {
    content: '';
    position: absolute;
    width: 50%;
    height: 100%;
    top: 0;
    left: 50%;
    z-index: 1;
    transform: rotateY(0deg);
    transform-origin: center left;
    animation: askAiBtnAnim 2s 3 ease-out; // initial animation
    background: conic-gradient(from 180deg at 0% 50%, #e01a2b 50%, #6750a4 75%, #e01a2b 100%);
  }

  &:hover::after,
  &:focus::after {
    animation: askAiBtnAnim 2s infinite ease-out;
  }
}
</style>
<style lang="scss" brand="bcom" scoped>
.ask-ai-gecx-btn {
  width: 36px;
  height: 36px;
  :deep(img) {
    width: 36px;
    height: 36px;
  }

  @include breakpoint(large up) {
    width: 69px;
    height: 33px;
    :deep(img) {
      width: 69px;
      height: 33px;
    }
  }
}
</style>
